export default __webpack_public_path__ + "static/media/038-butcher.774c08d8.svg";